import { ErrorParser } from "../ErrorParser";
import { isObject } from "lodash-es";

/**
 * Ej: Question id does not exist in this combo
 */
export class PreguntaNoEstaEncuestaParser implements ErrorParser {
    public puedeLeerError(error: string): boolean {
        return !isObject(error) && error.includes("Question id does not exist in this combo");
    }

    public traducir(): string {
        return "La pregunta no es parte de este combo.";
    }
}
